"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var _TimesCircle = _interopRequireDefault(require("@paprika/icon/lib/TimesCircle"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _helpers = require("@paprika/helpers");

var types = _interopRequireWildcard(require("./types"));

var sc = _interopRequireWildcard(require("./Input.styles"));

var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var a11yText = props.a11yText,
      clearIcon = props.clearIcon,
      className = props.className,
      defaultValue = props.defaultValue,
      icon = props.icon,
      isDisabled = props.isDisabled,
      isReadOnly = props.isReadOnly,
      hasClearButton = props.hasClearButton,
      hasError = props.hasError,
      onChange = props.onChange,
      size = props.size,
      value = props.value,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "clearIcon", "className", "defaultValue", "icon", "isDisabled", "isReadOnly", "hasClearButton", "hasError", "onChange", "size", "value"]);
  var isControlled = value !== undefined;
  var i18n = (0, _useI18n["default"])();

  var _React$useState = _react["default"].useState(hasClearButton && !isDisabled && !isReadOnly && (value || defaultValue)),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      shouldShowClearButton = _React$useState2[0],
      setShouldShowClearButton = _React$useState2[1];

  _react["default"].useEffect(function () {
    setShouldShowClearButton(hasClearButton && !isDisabled && !isReadOnly && (value || defaultValue));
  }, [hasClearButton, isDisabled, isReadOnly, value, defaultValue]);

  var refInput = _react["default"].useRef();

  var refBest = ref || refInput;

  var handleChange = function handleChange(event) {
    if (!hasClearButton || isDisabled || isReadOnly) return;

    if (isControlled) {
      setShouldShowClearButton(Boolean(value));
    } else {
      setShouldShowClearButton(Boolean(event.target.value));
    }
  };

  var inputClearHandler = function inputClearHandler() {
    if (!isControlled) {
      if (refBest.current) refBest.current.value = "";
      setShouldShowClearButton(false);
    }

    onChange(null);
  };

  var renderClear = function renderClear() {
    if (!shouldShowClearButton) return null;
    var iconSize = size === types.LARGE ? types.MEDIUM : types.SMALL;
    return /*#__PURE__*/_react["default"].createElement(_button["default"].Icon, {
      a11yText: i18n.t("input.clear_button.aria_label"),
      className: "form-input__clear",
      kind: types.MINOR,
      size: iconSize,
      onClick: inputClearHandler
    }, clearIcon || /*#__PURE__*/_react["default"].createElement(_TimesCircle["default"], null));
  };

  var renderIcon = function renderIcon() {
    if (!props.icon) return null;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "form-input__icon"
    }, props.icon);
  };

  var styleProps = {
    size: size,
    hasClearButton: hasClearButton
  };
  var rootClasses = (0, _classnames["default"])("form-input", "form-input--".concat(size), {
    "form-input--has-icon": icon
  }, {
    "form-input--is-disabled": isDisabled
  }, {
    "form-input--is-readonly": isReadOnly
  }, {
    "form-input--has-error": hasError
  }, className);
  return /*#__PURE__*/_react["default"].createElement(sc.Input, (0, _extends2["default"])({}, styleProps, {
    className: rootClasses
  }), renderIcon(a11yText), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    "aria-invalid": hasError,
    "aria-label": a11yText,
    "data-pka-anchor": "input",
    disabled: isDisabled,
    readOnly: isReadOnly
  }, moreProps, {
    className: "form-input__input",
    value: isControlled ? value : undefined,
    defaultValue: !isControlled ? defaultValue : undefined,
    onChange: (0, _helpers.callAll)(handleChange, onChange),
    ref: ref || refInput
  })), renderClear());
});

Input.types = {
  size: constants.defaultSize,
  type: types.inputValidTypes
};
var propTypes = {
  /** Provides a non-visible label for this input for assistive technologies. */
  a11yText: _propTypes["default"].string,

  /** Sets the class for the input. */
  className: _propTypes["default"].string,

  /** Custom icon for the clear action in the input. */
  clearIcon: _propTypes["default"].node,

  /** Sets the default input value for an uncontrolled component. */
  defaultValue: _propTypes["default"].string,

  /** If true displays a clear button inside the input if it contains a value. */
  hasClearButton: _propTypes["default"].bool,

  /** If true displays a red border around input to show error. */
  hasError: _propTypes["default"].bool,

  /** Displays an icon inside the input. */
  icon: _propTypes["default"].node,

  /** If true it makes the input disabled. */
  isDisabled: _propTypes["default"].bool,

  /** If true it makes the input read only. */
  isReadOnly: _propTypes["default"].bool,

  /**
   * Callback to be executed when the input value is changed. Receives the
   * onChange event as an argument, except when the clear button is clicked,
   * then the argument is null. Needed when value prop is provided (component
   * is controlled).
   */
  onChange: _propTypes["default"].func,

  /** Changes the size of the input. */
  size: _propTypes["default"].oneOf([Input.types.size.SMALL, Input.types.size.MEDIUM, Input.types.size.LARGE]),

  /** Allows user to specify the type of input. */
  type: _propTypes["default"].oneOf([Input.types.type.EMAIL, Input.types.type.NUMBER, Input.types.type.PASSWORD, Input.types.type.SEARCH, Input.types.type.TELEPHONE, Input.types.type.TEXT, Input.types.type.URL]),

  /** The value inside of the input */
  value: _propTypes["default"].string
};
var defaultProps = {
  a11yText: null,
  clearIcon: null,
  className: null,
  defaultValue: null,
  hasClearButton: false,
  hasError: false,
  icon: null,
  isDisabled: false,
  isReadOnly: false,
  onChange: function onChange() {},
  size: Input.types.size.MEDIUM,
  type: Input.types.type.TEXT,
  value: undefined
};
Input.displayName = "Input";
Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
var _default = Input;
exports["default"] = _default;
//# sourceMappingURL=Input.js.map